// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__2cd1o","ranges":"BmiRanges_ranges__ajuY3"};